// extracted by mini-css-extract-plugin
export default {"container":"FormContainer_container__Fr16M"};